<button type="button"
        class="ace-btn btn-text has-icon btn-secondary"
        [ngClass]="{'active': isFilterVisible }"
        (click)="onFilterClick()"
        title="Toggle filters">
    <i class="fa fa-filter"></i>
</button>
